import React from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import uiTexts from 'data/ui-texts';
import Button from 'components/ui/button/button';
import './game-end.scss';

const GameEnd = ({languageId, deviceInfo, goToPage}) => {

	return (
		<div className={'GameEnd ' + deviceInfo.orientation}>

			{/* Home btn */}
			<div className="GameEnd-homeBtn" onClick={() => {goToPage('settings');}} />
			
			{/* Content */}
			<div className="GameEnd-content">
				{/* Game progress */}
				<GameProgress 
					languageId={languageId}
					progressStepId={'results'}
					deviceInfo={deviceInfo}
				/>
				<div className="GameEnd-title">
					<span>{(getText('pages_gameEndTitle', languageId))}</span>
				</div>

				<div className="GameEnd-text">{renderMarkdown(getText('pages_gameEndText', languageId))}</div>
				<div className="GameEnd-items">
					{uiTexts.pages.gameEndItems.map((item, index) => {
						return (
							<span key={index}>{(index + 1)}. {getText(item, languageId)}</span>
						);
					})}
				</div>
			</div>

			<div className="GameEnd-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {goToPage('game-experiment-presentation');}}
				/>
			</div>

		</div>
	);
};

GameEnd.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameEnd;